import { Typography, alpha, styled } from '@mui/material'

import { Info as InfoIcon } from '@mui/icons-material'
import Stack from '../Stack.common'
import OwnTooltip from '../Tooltip.common'

const StatStyled = styled(Stack)(({ theme }) => ({
  backgroundColor: theme.palette.white,
  border: `1px solid ${theme.palette.blockBorder}`,
  boxShadow: `0px 2px 20px ${alpha(theme.palette.black, 0.05)}`,
  height: '100%',
  padding: '20px',
  width: '100%',
  maxWidth: '100%',
  position: 'relative',
}))

const TitleIconStyled = styled('div')({
  display: 'flex',
  alignItems: 'center',
  '& svg': {
    width: '15px',
    height: '15px',
  },
})

export interface CardGraphProps {
  title: string
  icon: JSX.Element
  tooltip?: string
  children?: React.ReactNode | React.ReactNode[]
}

const CardGraph = (props: CardGraphProps) => {
  const { title, icon, tooltip, children } = props

  return (
    <StatStyled spacing="35px" alignItems="center">
      <Stack alignSelf="flex-start" direction="row" spacing="6px" alignItems="center">
        <TitleIconStyled>{icon}</TitleIconStyled>
        <Typography variant="h4">{title}</Typography>
        {tooltip && (
          <OwnTooltip title={tooltip}>
            <InfoIcon color="primary" />
          </OwnTooltip>
        )}
      </Stack>
      {children}
    </StatStyled>
  )
}
export default CardGraph

/*



*/
